import { Button, Flex } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { StyledFloatingContainer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/styled.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TEST_ELEMENT_IDS, makeComplexDataTestId } from '@dealstack/shared/tests/testElementIds';

interface Props {
	onAddAddress?: () => void;
	onAddRelatedPerson?: () => void;
	onAddBankAccount?: () => void;
	onAddTaxInformation?: () => void;
	onAddEmploymentRecord?: () => void;
	onAddPersonToMip?: () => void;
	onAddLinkedDeal?: () => void;
}

export const FloatingDetailsActions = ({
	onAddAddress,
	onAddRelatedPerson,
	onAddBankAccount,
	onAddTaxInformation,
	onAddEmploymentRecord,
	onAddPersonToMip,
	onAddLinkedDeal,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<>
			<Flex pb="4rem"></Flex>
			<StyledFloatingContainer>
				{onAddAddress && (
					<Button
						onClick={onAddAddress}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'ADDRESS'
						)}
					>
						{tCapManage('basic_details.address_form.add_address')}
					</Button>
				)}
				{onAddBankAccount && (
					<Button
						onClick={onAddBankAccount}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'BANK_ACCOUNT'
						)}
					>
						{tCapManage('basic_details.address_form.add_bank_account')}
					</Button>
				)}
				{onAddTaxInformation && (
					<Button
						onClick={onAddTaxInformation}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'TAX_INFO'
						)}
					>
						{tCapManage('basic_details.address_form.add_tax_info')}
					</Button>
				)}
				{onAddRelatedPerson && (
					<Button
						onClick={onAddRelatedPerson}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'RELATED_PEOPLE'
						)}
					>
						{tCapManage('basic_details.address_form.add_related_person')}
					</Button>
				)}
				{onAddEmploymentRecord && (
					<Button
						onClick={onAddEmploymentRecord}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'EMPLOYMENT_RECORD'
						)}
					>
						{tCapManage('basic_details.address_form.add_employment_record')}
					</Button>
				)}
				{onAddPersonToMip && (
					<Button
						onClick={onAddPersonToMip}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'PERSON_TO_MIP'
						)}
					>
						{tCapManage('basic_details.add_person_to_mip')}
					</Button>
				)}
				{onAddLinkedDeal && (
					<Button
						onClick={onAddLinkedDeal}
						variant="default"
						rightSection={<Icon variant="add" size="lg" />}
						data-testid={makeComplexDataTestId(
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_SECTION_ADD_TRIGGER,
							'LINKED_DEAL'
						)}
					>
						{tCapManage('fund_person_link.add_linked_deal')}
					</Button>
				)}
			</StyledFloatingContainer>
		</>
	);
};
